import camelcaseKeys from 'camelcase-keys';
import type { Configuration, FuelTransaction } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import type { UpdateTransactionRequest } from './Definitions/APITypes';

export class NewFuelCardRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getFuelTransaction = async (transactionId: string): Promise<FuelTransaction> => {
    const requestData: IRequest = {
      endpoint: `/transactions/${transactionId}`,
      method: HttpMethod.GET,
    };

    const response = await this.requester.request(requestData);

    return camelcaseKeys(response.data, { deep: true }) as FuelTransaction;
  };

  public updateFuelTransaction = (transactionId: string, updateRequest: UpdateTransactionRequest): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `/transactions/${transactionId}`,
      method: HttpMethod.PUT,
      body: JSON.stringify(updateRequest),
    };

    return this.requester.request(requestData).then();
  };
}

export default NewFuelCardRequester;
